(() => {
    const SELECTORS = {
        mobileToggle: '[data-mf-mobile-toggle], [data-show-mobile-menu], .mobile-menu__toggle-button',
        drawer: '#mobileDrawer',
        backdrop: '[data-mobile-backdrop]',
        closeBtn: '#mobileDrawerClose',
        backBtn: '#mobileDrawerBack',
        contentRoot: '.mobile-drawer__content-root',
        tabsContainer: '.mobile-drawer__tabs',
        sectionItem: '.mobile-section-item',
        panel: '.mobile-panel',
        title: '.mobile-drawer__title',
        chevron: '.chev',
        tabButton: '.mobile-drawer__tab',
        section: '.mobile-drawer__section',
        flowerSection: '#mobileSectionFlowers',
        additionsSection: '#mobileSectionAdditions',
        mobileTabFlowers: '#mobileTabFlowers',
        mobileTabAdditions: '#mobileTabAdditions',
    };

    const mobileToggle = document.querySelector(SELECTORS.mobileToggle);
    const drawer = document.querySelector(SELECTORS.drawer);

    if (!mobileToggle || !drawer) {
        console.warn('mobile drawer: toggle or drawer not found');
        return;
    }

    const contentRoot = drawer.querySelector(SELECTORS.contentRoot);
    const tabsContainer = drawer.querySelector(SELECTORS.tabsContainer);
    const sectionItems = [...document.querySelectorAll(SELECTORS.sectionItem)];

    const flowerSection = document.querySelector(SELECTORS.flowerSection);
    const additionsSection = document.querySelector(SELECTORS.additionsSection);
    const mobileTabFlowers = document.querySelector(SELECTORS.mobileTabFlowers);
    const mobileTabAdditions = document.querySelector(SELECTORS.mobileTabAdditions);

    const getTitleEl = () => drawer.querySelector(SELECTORS.title);

    const getCleanTitle = (el) => {
        if (!el) return '';
        const clone = el.cloneNode(true);
        clone.querySelectorAll(SELECTORS.chevron).forEach((n) => n.remove());
        return clone.textContent.trim();
    };

    const setPanelsVisibility = (activePanel = null) => {
        drawer.querySelectorAll(SELECTORS.panel).forEach((panel) => {
            const on = panel === activePanel;
            panel.style.display = on ? '' : 'none';
            panel.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
    };

    const showRootContent = () => {
        setPanelsVisibility(null);

        if (contentRoot) contentRoot.style.display = '';
        if (tabsContainer) tabsContainer.style.display = '';

        drawer.classList.remove('panel-open');

        const titleEl = getTitleEl();
        if (titleEl) {
            titleEl.classList.remove('active');
            titleEl.textContent = '';
        }
    };

    const lockScroll = () => {
        if (window.PXUTheme?.predictiveSearch?.lockBodyScroll) {
            window.PXUTheme.predictiveSearch.lockBodyScroll();
        } else {
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
        }
    };

    const unlockScroll = () => {
        if (window.PXUTheme?.predictiveSearch?.unlockBodyScroll) {
            window.PXUTheme.predictiveSearch.unlockBodyScroll();
        } else {
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        }
    };

    const setDrawerOpen = (isOpen) => {
        // Первый показ снимает display:none с содержимого (см. CSS .is-warmed):
        // до этого фоновые картинки пунктов меню не загружаются вовсе.
        if (isOpen) drawer.classList.add('is-warmed');
        drawer.classList.toggle('open', isOpen);
        drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

        if (isOpen) lockScroll();
        else unlockScroll();

        if (!isOpen) showRootContent();
    };

    const initMobileDrawer = () => {
        let currentPanelKey = null;

        const resetDrawer = () => {
            setPanelsVisibility(null);

            const titleEl = getTitleEl();
            if (titleEl) {
                titleEl.classList.remove('active');
                titleEl.textContent = '';
            }

            if (flowerSection) flowerSection.style.display = '';
            if (mobileTabFlowers) {
                mobileTabFlowers.classList.add('active');
                mobileTabFlowers.setAttribute('aria-selected', 'true');
            }

            if (additionsSection) additionsSection.style.display = 'none';
            if (mobileTabAdditions) {
                mobileTabAdditions.classList.remove('active');
                mobileTabAdditions.setAttribute('aria-selected', 'false');
            }

            if (tabsContainer) tabsContainer.style.display = '';
            if (contentRoot) contentRoot.style.display = '';

            drawer.classList.remove('panel-open');
        };

        const openDrawer = () => {
            setDrawerOpen(true);
            showRootContent();
            currentPanelKey = null;
        };

        const closeDrawer = () => {
            resetDrawer();
            setDrawerOpen(false);
            currentPanelKey = null;
        };

        const showPanel = (key, title = '') => {
            const panel = drawer.querySelector(`#panel-${key}`);
            if (!panel) {
                console.warn('mobile panel not found:', key);
                return;
            }

            if (contentRoot) contentRoot.style.display = 'none';
            if (tabsContainer) tabsContainer.style.display = 'none';

            setPanelsVisibility(panel);
            drawer.classList.add('panel-open');
            currentPanelKey = key;

            const titleEl = getTitleEl();
            if (titleEl) titleEl.textContent = title;
        };

        const hidePanel = () => {
            showRootContent();
            currentPanelKey = null;
        };

        const toggleDrawer = () => {
            drawer.classList.contains('open') ? closeDrawer() : openDrawer();
        };

        sectionItems.forEach((btn) => {
            btn.addEventListener('click', () => {
                const key = btn.getAttribute('data-target');
                if (key) showPanel(key, getCleanTitle(btn));
            });
        });

        mobileToggle.addEventListener('click', toggleDrawer);

        drawer.querySelector(SELECTORS.backdrop)?.addEventListener('click', closeDrawer);
        drawer.querySelector(SELECTORS.closeBtn)?.addEventListener('click', closeDrawer);

        drawer.querySelector(SELECTORS.backBtn)?.addEventListener('click', (e) => {
            e.preventDefault();
            if (!drawer.classList.contains('open')) return;

            if (drawer.classList.contains('panel-open')) {
                hidePanel();
            } else {
                closeDrawer();
            }
        });

        document.addEventListener('click', (e) => {
            if (!drawer.classList.contains('open')) return;

            const clickedInsideDrawer = drawer.contains(e.target);
            const clickedToggle = mobileToggle.contains(e.target);

            if (!clickedInsideDrawer && !clickedToggle) {
                closeDrawer();
            }
        });
    };

    const initMobileDrawerTabs = () => {
        const tabButtons = [...document.querySelectorAll(SELECTORS.tabButton)];
        if (!tabButtons.length) return;

        const sections = [...document.querySelectorAll(SELECTORS.section)];

        const resolveSectionId = (raw, btn) => {
            const key = (raw || '').replace(/^#/, '').replace(/^panel-/i, '').toLowerCase();
            if (key.includes('addition')) return 'mobileSectionAdditions';
            if (key.includes('flower')) return 'mobileSectionFlowers';

            const text = btn.textContent.trim().toLowerCase();
            if (text.includes('addition')) return 'mobileSectionAdditions';
            if (text.includes('flower')) return 'mobileSectionFlowers';
            return null;
        };

        const getRawTarget = (btn) =>
            btn.dataset.target ||
            btn.dataset.tab ||
            (btn.getAttribute('href')?.startsWith('#') ? btn.getAttribute('href') : null);

        const hideAllSections = () =>
            sections.forEach((s) => {
                s.style.display = 'none';
                s.setAttribute('aria-hidden', 'true');
            });

        const showSection = (id) => {
            const section = document.getElementById(id);
            if (!section) return;
            hideAllSections();
            section.style.display = '';
            section.setAttribute('aria-hidden', 'false');
        };

        const activateButton = (btn) => {
            tabButtons.forEach((b) => {
                const on = b === btn;
                b.classList.toggle('active', on);
                b.setAttribute('aria-selected', on ? 'true' : 'false');
                b.setAttribute('tabindex', on ? '0' : '-1');
                if (!b.hasAttribute('role')) b.setAttribute('role', 'tab');
            });

            const sectionId = resolveSectionId(getRawTarget(btn), btn);
            if (sectionId) showSection(sectionId);
        };

        tabButtons.forEach((btn) =>
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                activateButton(btn);
            })
        );

        const initial = tabButtons.find((b) => b.getAttribute('aria-selected') === 'true') || tabButtons[0];
        initial ? activateButton(initial) : hideAllSections();
    };

    initMobileDrawer();
    initMobileDrawerTabs();
})();